import type { MonitoringProvider } from './types'

/**
 * No-op monitoring provider that does nothing
 *
 * Useful for:
 * - Testing environments where you don't want actual monitoring calls
 * - Fallback when no other providers are configured
 * - Disabling monitoring without changing code
 */
export const createNoopProvider = (): MonitoringProvider => ({
  trackError(): void {
    // Do nothing
  },

  addPageAction(): void {
    // Do nothing
  },
})
